<template>
  <div>
    <DashboardHeader title="Edit Fees">
      <v-row class="mt-4">
        <v-col cols="2" class="pb-4"
          ><v-switch
            :disabled="selectedFeesData.length < 1"
            v-model="selectAll"
            label="Select All"
            class="ml-4 mt-0"
            @change="selectAllFees()"
          ></v-switch
        ></v-col>
        <v-col cols="4"
          ><v-btn
            small
            :style="{ 'background-color': 'blue', color: 'white' }"
            rounded
            @click="editFeesYear()"
            >Copy Selected To Another Year</v-btn
          ></v-col
        >
        <v-col cols="4"
          ><v-btn
            small
            :style="{ 'background-color': '#FF9800', color: 'white' }"
            rounded
            @click="editFeesDeposit()"
            >Bulk Edit Fees</v-btn
          ></v-col
        >
      </v-row>
      <v-layout row wrap class="mx-2">
        <v-flex
          md3
          xs12
          v-for="(fee, i) in selectedFeesData"
          :key="i + Math.random()"
        >
          <v-card class="mt-4 mx-2" elevation="24" shaped>
            <v-card>
              <v-checkbox
                class="ml-2 shrink"
                :value="fee.id"
                v-model="selectedFees"
              >
              </v-checkbox>
              <v-row>
                <v-col cols="6" class="mx-1">
                  <v-card-subtitle>
                    <v-text-field
                      label="Fee ID"
                      v-model="fee.fid"
                    ></v-text-field>
                  </v-card-subtitle>
                </v-col>
                <v-col cols="4" class="mx-1 mt-10"
                  >{{ getCurrency }} 123456</v-col
                >
              </v-row>

              <v-row>
                <v-col cols="5" class="mx-1">
                  <v-card-subtitle>
                    <v-text-field
                      label="Starting Year"
                      v-model="fee.year"
                    ></v-text-field>
                  </v-card-subtitle>
                </v-col>
                <v-col cols="5" class="mx-1">
                  <v-card-subtitle>
                    <v-text-field
                      label="Deposit"
                      v-model="fee.deposit"
                    ></v-text-field>
                  </v-card-subtitle>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="5" class="mx-1">
                  <v-card-subtitle>
                    <v-text-field
                      :label="`Monthly Payments (${getCurrency})`"
                      v-model="fee.monthly"
                    ></v-text-field>
                  </v-card-subtitle>
                </v-col>
                <v-col cols="5" class="mx-1">
                  <v-card-subtitle>
                    <v-text-field
                      label="No. of Months"
                      v-model="fee.months"
                    ></v-text-field>
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
      <GlobalDialogSlot
        :title="dialogTitle"
        :dialog="dialog"
        @close-dialog="closeDialog"
      >
        <v-card v-if="isEditYear">
          <v-row>
            <v-col cols="4"></v-col>
            <v-col cols="4">
              <v-text-field
                label="Edit Year"
                v-model="editedYear"
              ></v-text-field>
            </v-col>
            <v-col cols="4"></v-col>
          </v-row>

          <v-row>
            <v-col cols="4"></v-col>
            <v-col cols="4">
              <v-btn
                rounded
                :color="getThemeColor"
                dark
                @click="submitEditedYear()"
                >Submit</v-btn
              >
            </v-col>
            <v-col cols="4"></v-col>
          </v-row>
        </v-card>
        <v-card v-else-if="isEditDeposit">
          <v-row class="mx-2">
            <v-col cols="4">
                <v-text-field
                label="Edit Deposit"
                v-model="editedDeposit"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                label="Edit Monthly"
                v-model="monthly"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
                <v-text-field
                label="Edit No. of Months"
                v-model="months"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mx-2">
            <v-col cols="4">
                <v-text-field
                label="Edit Starting Month"
                v-model="startingMonth"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-btn
                rounded
                :color="getThemeColor"
                dark
                @click="submitEditedDeposit()"
                >Submit</v-btn
              >
            </v-col>
            <v-col cols="4"></v-col>
          </v-row>
        </v-card>
      </GlobalDialogSlot>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";

export default {
  components: {
    DashboardHeader,
    GlobalDialogSlot,
  },
  computed: {
    getGlobalConfirmDelete() {
      return this.$store.getters.getGlobalConfirmDelete;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .postDataWithToken(
        "/auth/get-selected-fees",
        { selectedFees: this.$route.params.selectedFees },
        this.getAccessToken
      )
      .then((selectedFeesData) => {
        this.selectedFeesData = selectedFeesData;
        this.$store.commit("setLoader", false);
      });
  },
  data() {
    return {
      dialog: false,
      selectAll: false,
      selectedFeesData: [],
      selectedFees: [],
      isEditYear: false,
      isEditDeposit: false,
      dialogTitle: null,
      editedYear: new Date().getFullYear(),
      editedDeposit: 0,
      monthly:0,
      months:11,
      startingMonth:1
    };
  },
  methods: {
    selectAllFees() {
      if (this.selectAll) {
        this.selectedFees = [];
        this.selectedFeesData.forEach((selectedFeeData) => {
          this.selectedFees.push(selectedFeeData.id);
        });
      } else {
        this.selectedFees = [];
      }
    },
    editFeesYear() {
      if (this.selectedFees.length < 1) {
        alert("Select Atleast 1 Fee Structure");
        event.preventDefault();
      } else {
        this.isEditYear = true;
        this.dialogTitle = "Copy Fees To Another Year";
        this.dialog = true;
      }
    },
    editFeesDeposit() {
      if (this.selectedFees.length < 1) {
        alert("Select Atleast 1 Fee Structure");
        event.preventDefault();
      } else {
        this.isEditDeposit = true;
        this.dialogTitle = `Bulk Edit ${this.selectedFees.length} Fees`;
        this.dialog = true;
      }
    },
    submitEditedYear() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/submit-fees-edited-year",
          { selectedYear: this.editedYear, selectedFees: this.selectedFees },
          this.getAccessToken
        )
        .then((selectedFeesData) => {
          this.selectedFeesData = selectedFeesData;
          this.$store.commit("setLoader", false);
          this.closeDialog();
        });
    },
    submitEditedDeposit() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/submit-fees-deposit",
          {
            selectedFees: this.selectedFees,
            editedDeposit: this.editedDeposit,
            monthly : this.monthly,
            months : this.months,
            startingMonth: this.startingMonth
          },
          this.getAccessToken
        )
        .then((selectedFeesData) => {
          this.selectedFeesData = selectedFeesData;
          this.$store.commit("setLoader", false);
          this.closeDialog();
        });
    },
    closeDialog() {
      this.dialog = false;
      this.isEditYear = false;
      this.isEditDeposit = false;
    },
  },
};
</script>

<style></style>
